<div class="loader flex flex-grow rounded-full border-8 border-t-8 border-primary-100 ease-linear"></div>
